import React from 'react';

import { Button, ButtonProps } from '@mui/material';

import useStyles from './styles';

type Props = Omit<ButtonProps, 'variant' | 'color' | 'disableElevation' | 'disableFocusRipple'> & {
    color?: 'light' | 'dark';
};

const ActionButton: React.FC<Props> = ({ className, color = 'light', href, ...props }) => {
    const { classes, cx } = useStyles({ color });

    return (
        <Button
            {...props}
            className={cx(classes.button, className)}
            variant="contained"
            disableElevation
            disableFocusRipple
            {...(href
                ? {
                      href,
                      rel: 'nofollow noopener noreferrer',
                      target: '_blank'
                  }
                : {})}
        />
    );
};

export default ActionButton;
